import { HTMLAttributes, createElement } from 'react';
import cn from 'classnames';

import '@mos-utils/css/lib/typography/Lead.css';

function Lead<T = HTMLParagraphElement>({
  size,
  adaptive,
  tag = 'p',
  className = '',
  children,
  ...props
}: Props<T>) {
  return createElement(
    tag,
    {
      className: cn(
        { 'mos-lead': true, 'mos-lead_adaptive': adaptive },
        `mos-lead_size_${size}`,
        className
      ),
      props
    },
    children
  );
}

interface Props<T = HTMLParagraphElement> extends HTMLAttributes<T> {
  size: 'big' | 'medium' | 'small';
  adaptive?: boolean;
  tag?: string;
}

Lead.defaultProps = {
  adaptive: false,
  tag: 'p',
  children: [],
  className: ''
};

export default Lead;
